import { API } from '../API';

export const projectsApi = {
  list() {
    return API.fetch('GET', '/API/v2/projects');
  },

  create(name, order) {
    const body = { name };
    if (order !== undefined) body.order = order;
    return API.fetch('POST', '/API/v2/projects', null, body);
  },

  /** @param {number} projectId @param {{ name?: string, order?: number, case_ids?: number[] }} [updates] */
  update(projectId, { name, order, case_ids } = {}) {
    const body = {};
    if (name !== undefined) body.name = name;
    if (order !== undefined) body.order = order;
    if (case_ids !== undefined) body.case_ids = case_ids;
    if (Object.keys(body).length === 0) return Promise.resolve(null);
    return API.fetch('PATCH', `/API/v2/projects/${projectId}`, null, body);
  },

  delete(projectId) {
    return API.fetch('DELETE', `/API/v2/projects/${projectId}`);
  },

  moveCase(caseId, targetProjectId) {
    return API.fetch(
      'POST',
      `/API/v2/projects/cases/${caseId}/move`,
      null,
      { target_project_id: targetProjectId },
    );
  },
};
